<template>
  <span
    v-if="country"
    class="inline-flex items-center gap-1.5 rounded-full bg-opacity-50 px-2 py-1"
    :class="[mode === 'dark' ? 'bg-dark-border' : 'bg-black-10']"
  >
    <span
      v-if="getFlagEmojiByCountryName(country)"
      class="flex h-4 w-4 items-center justify-center rounded-full text-base"
    >
      {{ getFlagEmojiByCountryName(country) }}
    </span>
    <span v-else class="text-base">🌍</span>
    <span class="mt-[1px] block max-w-[120px] flex-1 truncate">
      {{ getCountryName(country) }}</span
    >
  </span>
  <span v-else>-</span>
</template>

<script>
export default {
  name: "Country",
  props: {
    mode: String,
    country: String,
    countries: {
      type: Array,
      default: [],
    },
  },
  methods: {
    getCountryName(countryName) {
      if (typeof countryName !== "string" || !countryName.trim()) {
        return null;
      }
      const trimmedName = countryName.trim();
      const normalizedName =
        this.normalizeCountryName(trimmedName).toLowerCase();
      const match = this.countries.find(
        (c) =>
          c.code.toLowerCase() === normalizedName ||
          c.country.toLowerCase() === normalizedName,
      );
      return match ? match.country : countryName;
    },
    getFlagEmojiByCountryName(countryName) {
      if (typeof countryName !== "string" || !countryName.trim()) {
        return null;
      }
      const trimmedName = countryName.trim();
      const normalizedName = this.normalizeCountryName(trimmedName);
      let countryCode = "";
      if (normalizedName.length === 2 || normalizedName.length === 3) {
        countryCode = normalizedName.toUpperCase();
      } else {
        const country = this.countries.find(
          (c) => c.country.toLowerCase() === normalizedName.toLowerCase(),
        );
        if (!country || !country.code) {
          return null;
        }
        countryCode = country.code.toUpperCase();
      }
      return this.convertCountryCodeToFlag(countryCode);
    },
    normalizeCountryName(countryName) {
      const aliases = {
        USA: "United States",
        US: "United States",
        UK: "United Kingdom",
        UAE: "United Arab Emirates",
        DRC: "Democratic Republic of the Congo",
        CAR: "Central African Republic",
      };
      const upperName = countryName.toUpperCase();
      return aliases[upperName] || countryName;
    },
    convertCountryCodeToFlag(countryCode) {
      if (!countryCode || countryCode.length !== 2) {
        return null;
      }
      return countryCode
        .toUpperCase()
        .split("")
        .map((char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        .join("");
    },
  },
};
</script>
